/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'open-source': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256 8.144c-141.152 0-256 114.848-256 256C0 369.456 66.016 465.36 164.224 502.768c4.096 1.632 8.704 1.376 12.672-.544 3.968-1.952 6.976-5.408 8.288-9.632l48-153.28c2.272-7.264-.864-15.136-7.52-18.784C204.896 309.072 192 287.472 192 264.144c0-35.296 28.704-64 64-64s64 28.704 64 64c0 23.328-12.896 44.928-33.664 56.416-6.656 3.648-9.824 11.52-7.52 18.784l48 153.28c1.312 4.224 4.32 7.68 8.288 9.632a16.23 16.23 0 006.976 1.6c1.92 0 3.872-.352 5.696-1.056C446.016 465.36 512 369.456 512 264.144c0-141.152-114.848-256-256-256z"/>'
  }
})
